import React, { useState } from 'react';
import './DemotionConfirmDialog.css';

function DemotionConfirmDialog({ contact, onClose, onDemote }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/backend/api/contacts/promote-to-marketer.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          contact_id: contact.id,
          action: 'demote'
        })
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          onDemote(data.contact);
          onClose();
        } else {
          setError(data.error || 'Failed to demote contact');
        }
      } else {
        setError('Server error occurred');
      }
    } catch (error) {
      console.error('Error demoting contact:', error);
      setError('Failed to demote contact');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="demotion-dialog-overlay" onClick={onClose}>
      <div className="demotion-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="demotion-dialog-header">
          <h2>⚠️ Demote {contact.first_name} {contact.last_name}</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="demotion-dialog-content">
          <div className="warning-message">
            <p>Are you sure you want to demote <strong>{contact.first_name} {contact.last_name}</strong> back to Customer?</p>
            <p>This will:</p>
            <ul>
              <li>Change their status from Marketer to Customer</li>
              <li>Switch their tasks to Customer tasks</li>
              <li>Preserve their network company information for history</li>
            </ul>
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="demotion-dialog-actions">
            <button 
              type="button" 
              className="cancel-btn"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="button" 
              className="demote-btn"
              onClick={handleConfirm}
              disabled={loading}
            >
              {loading ? 'Demoting...' : '⬇️ Demote to Customer'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DemotionConfirmDialog;

